import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import useHelpers from 'hooks/helpers';
import { ArticleData } from 'model/Article';
import { useCalculatedArticleFields } from 'hooks/useCalculatedArticleField';
import { useI18n } from 'next-localization';
import { usePageData } from 'lib/page-data/PageDataContext';

const useArticleDataAttributes = (
  pressRelease?: ArticleData
): Record<string, string | string[] | boolean | number | undefined | null> => {
  const { getEntityType, getArticleType } = useCalculatedArticleFields();
  const { t } = useI18n();

  return pressRelease
    ? {
        'data-article_type': t(getArticleType(pressRelease.template)) ?? t('article'),
        'data-article_entity_type': getEntityType(pressRelease.template) ?? '',
        'data-article_title': pressRelease.pressReleaseTitle.value ?? '',
        'data-article_publication_date':
          pressRelease.pressReleasePublicationDate.formattedDateValue ?? '',
        'data-article_content_type':
          pressRelease.pressReleaseContentType.targetItem?.name.value ?? '',
        'data-article_duration': pressRelease.duration?.value ?? 0,
        'data-press_release_platform':
          pressRelease.pressReleasePlatform.targetItem?.name.value ?? '',
        'data-article_strapline': pressRelease.pressReleaseDescription?.value ?? '',
      }
    : {};
};

const PressReleaseBody = ({ rendering }: ComponentProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  const { pressReleaseData } = usePageData('pressRelease') ?? {};
  const dataAttributes = useArticleDataAttributes(pressReleaseData);

  return (
    <section
      id={anchorId}
      data-e2e-component-uid={rendering.uid}
      // The class `data-attributes-container` is used by Sitecore search for finding the DOM element
      className="container background-white default-section-padding data-attributes-container"
      {...dataAttributes}
    >
      <div className="row d-flex justify-content-start">
        <div className="col-12 col-md-8 col-lg-8">
          <Placeholder
            name="abrdn-article-body"
            className="press-release-body d-flex flex-column"
            rendering={rendering}
            articleBody
          />
        </div>
      </div>
    </section>
  );
};

export default PressReleaseBody;
